<template>
	<div>
		<div class="container contacts-categories-scroller mt-5 pb-3 mb-3 mb-md-1">
			<div class="d-flex pe-2">
				<a role="button"
				   class="btn btn-outline-secondary me-4"
				   :class="{active: activeSlugs.indexOf(category.slug) !== -1}"
				   v-for="category in categories.filter(c => c.display_on_row !== '2')"
				   @click="toggleCategory(category)"
				>
					{{ category.name }}
				</a>
			</div>
			<div class="d-flex pe-2 mt-3">
				<a role="button"
				   class="btn btn-outline-secondary me-4"
				   :class="{active: activeSlugs.indexOf(category.slug) !== -1}"
				   v-for="category in categories.filter(c => c.display_on_row === '2')"
				   @click="toggleCategory(category)"
				>
					{{ category.name }}
				</a>
			</div>
		</div>

		<div class="container pb-7 pb-md-8">
			<div id="mg_contacts_result_container" class="row contacts-row-cols row-cols-1 row-cols-md-3 g-3 g-md-4 gy-4">
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
	props: {
		categories: {
			required: true
		},
	},

	data() {
		return {
			activeSlugs: [],
		}
	},

	created ()  {
		this.filter()
	},

	watch: {
		activeSlugs: {
			handler () {
				this.filter()
			},
			deep: true
		}
	},

	methods: {

		toggleCategory (category) {
			const index = this.activeSlugs.indexOf(category.slug)
			if (index !== -1) {
				this.activeSlugs.splice(index, 1);
			} else {
				this.activeSlugs.push(category.slug)
			}
		},

		filter() {
			const ajaxUrl = window.ajax_url

			axios({
				method: 'post',
				url: ajaxUrl + '?action=mg_contacts_fetch',
				data: qs.stringify({ slugs: this.activeSlugs })
			})
				.then((response) => {
					console.log('vue mg_contacts_fetch result')
					console.log(response.data)

					if (response.data.status === 'ok') {
						$('#mg_contacts_result_container').html(response.data.html)
					}
				})
				.catch((error) => {
					console.log('error')
					console.log(error)
					if (error.response && error.response.data) {
						// errorMsg = error.response.data.message
					}
				})
		}
	}
}
</script>
